import axios from 'axios';
import React from 'react';
import { withNamespaces } from 'react-i18next';
import { HiChevronDoubleDown } from 'react-icons/hi';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import KanbanBoard from './components/KanbanBoard';
import { API_URL_GET_KANBAN_BOARD, CM_API_URL_GET_KANBAN_BOARD } from '../../../common/constants';
import { isFeatureEnabledForActiveModule } from 'src/helpers/module_helper';
import './kanban-style.scss';
import FilteringComponent from './components/FilteringComponent';

class IndexKanban extends React.Component {

	constructor(props) {
		document.title = 'Kanban Board | SIP';
		super(props);
		this.state = {
			headers: {
				headers: {
					Authorization: `Bearer ${this.props.token}`,
				},
			},
			breadcrumbItems: [
				{ title: 'SIP', link: '/' },
				{ title: this.props.t('Kanban Board'), link: '#' },
			],

			loading: true,
			managerOptions: [],
			ownerOptions: [],
			columns: [],
			totalCount: 0,
			filter: {
				fromDate: '',
				toDate: '',
				owner: '',
				manager: '',
				sortBy: '',
			},
            filters: {},
			sortBy: '',
			sortOptions: [],
			periorityOptions: [
				{
					value: 'priority',
					label: (
						<>
							<HiChevronDoubleDown className='text-info' />
							<span style={{ marginLeft: 9 }}>High</span>
						</>
					),
				},
				{
					value: 'priority',
					label: (
						<>
							<HiChevronDoubleDown className='text-info' />
							<span style={{ marginLeft: 9 }}>Medium</span>
						</>
					),
				},
				{
					value: 'priority',
					label: (
						<>
							<HiChevronDoubleDown className='text-info' />
							<span style={{ marginLeft: 9 }}>Low</span>
						</>
					),
				},
			],
		};
        this.handleOnChange = this.handleOnChange.bind(this);
	}

	async fetchTasks(filter = {}) {
		this.setState({ loading: true });

		const content = {};
		const columns = [];

		try {
			const result = await axios.get(`${this.props.modules.active === 'wb' ? API_URL_GET_KANBAN_BOARD : CM_API_URL_GET_KANBAN_BOARD}`, {
				params: filter,
				headers: {
					Authorization: `Bearer ${this.props.token}`,
				},
			});

			if (result.status === 200 && result.data.data) {
				const data = result.data.data;
				const totalCount = result.data.data.reduce((acc, current) => {
					return acc + current.data.length;
				}, 0);

				// eslint-disable-next-line array-callback-return
				await data.map((item, index) => {
					let obj = {
						id: index,
						title: item.title,
						cards: [],
						columnsubtitle: `${item.data.length}`,
					};

					if (item.data && item.data.length > 0) {
						let cards = item.data.map((x, j) => {
							let xx = x;
							let xxx = {
								id: x.id,
								date: x.ended_at,
								title: x.name,
								status: x.status,
								subtitle: 'subtitle',
								priority: x.priority,
								secondaryId: x.secondary_id,
								progressValue: 100,
								caseId: x.report_case.secondary_case_id,
								primaryCaseId: x.report_case.case_id,
								caseTitle: x.report_case.description,
                                isRecurring: x.is_recurring,
                                recurrenceSecondaryId: x.recurrence_secondary_id,
								team: [
									{
										id: `task-owner-${x.report_case.secondary_case_id}-${x.ended_at}`,
										type: 'Task owner',
										name: x.owner_info?.name,
										avatar: x.owner_info?.avatar,
									},
									{
										id: `task-manager-${x.report_case.secondary_case_id}-${x.ended_at}`,
										type: 'Task Manager',
										name: x.manager_info?.name,
										avatar: x.manager_info?.avatar,
									},
								],
							};

							xx.id = `${item.title}-${j}`;
							xx.content = xxx;

							return xx;
						});

						obj.cards = cards;
					}

					columns.push(obj);
				});

				content.columns = columns;

				this.setState({
					content,
					columns,
					totalCount,
				});
			}
		} catch (error) {
			if (process?.env?.NODE_ENV === 'development') {
				console.error('this error only appears in the development environment:\nerror while fetching tasks:', error);
			}
		}

		this.setState({
			loading: false,
		});
	}

    handleOnChange(newFilters) {
        this.setState({
            filters: {
                ...this.state.filters,
                ...newFilters
            }
        }, () => {
            this.fetchTasks({
                ...newFilters
            })
        })
    }

	componentDidMount() {
		this.fetchTasks();
	}

	render() {
		if (!isFeatureEnabledForActiveModule('kanban-board')) {
			return <div className='page-content'>{this.props.t('Please upgrade your plan to access this feature')}.</div>;
		}

		return (
			<React.Fragment>
				<div className='page-content'>
					<Container fluid style={{ minHeight: '500px' }}>
						<Breadcrumbs 
                            title={this.props.t('Kanban Board')} 
                            breadcrumbItems={this.state.breadcrumbItems} 
                        />

                        <Row className="mb-4">
                            <Col sm='12' className="d-flex justify-content-end">
                                <FilteringComponent 
                                    onChange={this.handleOnChange}
                                />
                            </Col>
                        </Row>
						
						{!this.state.loading && (
							<KanbanBoard
								t={this.props.t}
								totalCount={this.state.totalCount}
								board={{
									sortBy: this.state.sortBy,
									columns: this.state.columns,
									content: this.state.content,
									placeholder: this.state.sortOptions,
								}}
								content={this.state.columns}
							/>
						)}
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const App = state.App;
	const { token, user } = state.Login;
    const { 
		Modules: modules 
	} = state;

	return {
		App,
		user,
		token,
        modules
	};
};

const mapDispachToProps = (dispach) => {
	return {};
};

export default withNamespaces()(withRouter(connect(mapStatetoProps, mapDispachToProps)(IndexKanban)));
